(function () {
  const THRESHOLDS = [
    250, 240, 230, 220, 210, 200, 190, 180, 170, 160, 150, 140, 130, 120, 110,
    100, 90, 80,
  ];

  function checkForClassAddition(mutationsList) {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches("abra-popup")) {
          const abraPopupObserver = new MutationObserver((mutations) => {
            mutations.forEach((m) => {
              if (
                m.type === "attributes" &&
                m.attributeName === "class" &&
                m.target.classList.contains("abra-popup--show")
              ) {
                document.body.classList.add("adbrActivated");
              }
            });
          });
          abraPopupObserver.observe(node, { attributes: true });
        }
      });
    });
  }

  const abraBodyObserver = new MutationObserver(checkForClassAddition);
  abraBodyObserver.observe(document.body, { childList: true, subtree: true });

  document.body.addEventListener("click", (event) => {
    if (event.target.closest(".abra-popup__close-button")) {
      document.body.classList.remove("adbrActivated");
    }
  });

  function clearAddToCartClasses() {
    document.body.classList.remove("addToCartActivated-0");
    THRESHOLDS.forEach((t) => {
      document.body.classList.remove(`addToCartActivated-${t}`);
    });
  }

  function btnScroll() {
    const stickyForm = document.querySelector(
      ".product-single__form-wrapper.sticky"
    );

    if (window.scrollY > 1200 && stickyForm) {
      const addToCartButtonHeight = stickyForm.offsetHeight;
      let addToCartActivated = 0;

      for (let i = 0; i < THRESHOLDS.length; i++) {
        if (addToCartButtonHeight > THRESHOLDS[i]) {
          if (i !== 0) {
            addToCartActivated = THRESHOLDS[i - 1];
          }
          break;
        }
      }

      clearAddToCartClasses();
      document.body.classList.add(`addToCartActivated-${addToCartActivated}`);
    } else {
      clearAddToCartClasses();
    }
  }

  window.addEventListener("scroll", btnScroll, { passive: true });
  btnScroll();
})();
